import CustomDescriptionItem from './CustomDescriptionItem';
import StatusTag from './ui/StatusTag';
import React from 'react';
import { Typography } from 'antd';
import { StatusHistory } from '../types';
const { Text } = Typography;

const TimelineView = ({ item }: { item: StatusHistory }) => {
  return (
    <div className={'space-y-2 border rounded p-2'}>
      <CustomDescriptionItem
        label={'Status Changed By'}
        content={item.createdBy}
      />
      <CustomDescriptionItem label={'Remarks'} content={item.remarks} />
      <CustomDescriptionItem
        label={'Status Changed Date'}
        content={item.timeCreated}
      />
      <div className={'flex'}>
        <Text strong className={'mr-1'}>
          Status:
        </Text>
        <div className={'w-20'}>
          <StatusTag status={item.status} />
        </div>
      </div>
    </div>
  );
};
export default TimelineView;
